import React from 'react'

import { useSelectedClosure } from '../hooks'

import ClosureList from './ClosureList'
import ClosureDetailsPanel from './ClosureDetailsPanel'

const ClosuresPanel = () => {
  const current = useSelectedClosure()

  if (current) return <ClosureDetailsPanel />
  return <ClosureList />
}
export default ClosuresPanel
